// extracted by mini-css-extract-plugin
export default {"whyRealGrass":"styles_whyRealGrass__8+hPo","infoWrapper":"styles_infoWrapper__L+qah","content":"styles_content__SKGOw","imgWrapper":"styles_imgWrapper__8z6NT"};